import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import mobile from '../../components/isMobile.vue';
import lsDetail from '../../components/lsDetail.vue';
import lsDetailScript from '../../components/lsDetailScript.vue';
import bigImg from '../../components/bigImg.vue';
import QRCode from 'qrcodejs2';
var stageUrl = process.env.VUE_APP_IMG_URL;
var qrcode;
var video, canvas, ctx, canvas_tmp, ctx_tmp;
export default {
  name: 'new3DDetail',
  data() {
    return {
      detail: {},
      detailCode: '',
      config: {},
      listPage: 1,
      list: [],
      showModels: [false, false, false],
      showDetail: false,
      isMobile: false,
      showBigErCode: false,
      columns: [],
      showBigImg: false,
      showBigImgIndex: 0,
      limit: 20,
      fileCode: '',
      paramsData: {},
      activeIndex: '',
      handelSlide: false,
      player: '',
      showVideo: false
    };
  },
  components: {
    mobile,
    lsDetail,
    bigImg,
    lsDetailScript
  },
  methods: {
    toIndex() {
      this.$router.push({
        name: 'new3DList',
        query: {
          fid: this.$route.query.fid,
          type: this.$route.query.type || 'white'
        },
        params: this.paramsData.page ? this.paramsData : JSON.parse(window.sessionStorage.getItem("searchKey"))
      });
    },
    getDetailById(id) {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/detail?id=${id}`).then(res => {
        this.detail.content = res.data.data.content;
      });
    },
    //获取栏目列表
    getColumn() {
      let query = {
        fid: this.$route.query.fid || '151066',
        formId: 112712,
        page: 1,
        limit: 50
      };
      this.$api.singleformList(query).then(res => {
        this.columns = res.data.map(item => {
          let nItem = {
            columnName: this.getConfigInFormData(item.formData, 'name')
          };
          return nItem;
        });
      });
    },
    clickErCode() {
      this.showBigErCode = !this.showBigErCode;
      if (!this.showBigErCode) return;
      let query = this.$route.query;
      let url = window.location.href;
      this.$nextTick(() => {
        this.$refs.erWeiMaCode.innerHTML = '';
        new QRCode(this.$refs.erWeiMaCode, {
          text: url,
          //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    clickDetail(index, m_index) {
      let target = this.list[index];
      let params = this.paramsData;
      params.index = this.list.findIndex(i => {
        return i.code == target.code;
      });
      let query = {
        fid: this.$route.query.fid,
        type: this.$route.query.type,
        code: target.code
      };
      if (target.autoCode) query.autoCode = target.autoCode;
      if (target.code == this.detailCode) query.index = m_index || 0;
      // let params = {
      //   page: parseInt(params.index/20)
      // }
      // window.sessionStorage.setItem("searchKey", JSON.stringify(params))
      this.$router.replace({
        name: 'new3DDetail',
        query,
        params
      });
    },
    // 点击左侧三个按钮
    showModel(index) {
      // if (index != 2 && this.detail.audio) this.$refs.voice.pause()
      if (index == 1) return window.open(this.detail.zhuanti);
      this.showModels = this.showModels.map((item, i) => {
        i == index ? item = !item : '';
        return item;
      });
      if (index == 2 && this.showModels[2]) {
        // 江西青铜虎在测试环境增加一个视频demo
        if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
          this.openVideo();
          this.showVideo = true;
          return;
        }
        this.$refs.voice.play();
      }
      if (index == 2 && !this.showModels[2]) {
        if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
          // this.$refs.videoPlayer.pause()
          // this.player.pause()
          return this.showVideo = false;
        }
        this.$refs.voice.pause();
      }
    },
    // 打开视频
    openVideo() {
      this.$nextTick(() => {
        this.$refs.videoPlayer.muted = false;
        this.$refs.videoPlayer.play();
        processorImg.doLoad();
      });
      this.detail.videoUrl = `${location.origin}${location.pathname}/hu.mp4`;
    },
    setParent(type, data) {
      if (type == 1) {
        this.list.splice(4, 0, data);
        this.swiperEl.slideTo(4);
        return;
      }
      this.detail = data;
      // if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
      //   this.detail.videoUrl = this.detail.video
      // }
      // document.addEventListener("DOMContentLoaded", () => {
      // });
      // 没有fileCode的老馆，增加activeIndex的判断
      // let m_index = this.$route.query.index || 0
      // let activeIndex = this.list.findIndex((item) => {return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index)})
      // // 当前数据不在列表中，继续获取列表
      // if (activeIndex == -1) {
      //   activeIndex = this.list.findIndex((item, index) => {return item.code == this.detail.code})
      //   this.activeIndex = activeIndex
      //   this.$nextTick(() => {
      //     this.swiperEl.slideTo(this.activeIndex)
      //     this.showDetail = true
      //   })
      // }
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          logo: this.getConfigInFormData(data.formData, 'logo', 'img'),
          title: this.getConfigInFormData(data.formData, 'title')
        };
        document.title = this.config.title || '文物综合展示系统';
        // if (this.paramsData.page && parseInt(this.paramsData.page) > 1) {
        //   // this.limit = parseInt(this.paramsData.index) < 100 ? parseInt(this.paramsData.index) + 3 : 50
        //   this.listPage = parseInt(this.paramsData.page)
        //   return this.getList() 
        // }
        this.getList();
      });
    },
    // 获取底部文物信息列表
    getList(type, limit) {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010,
        page: this.listPage,
        limit: this.limit || 20,
        searchStr: ''
      };
      let a = {
        filters: [[{
          alias: "showType",
          compt: "checklist",
          express: "match",
          range: null,
          val: ['电脑端与移动端']
        }]],
        model: 0
      };
      if (this.paramsData.page) {
        let params = this.paramsData;
        params.column && params.column != '全部' ? a.filters.push([{
          alias: "column",
          compt: "selectbox",
          express: "match",
          id: 41,
          range: null,
          val: [params.column]
        }]) : '';
        params.type ? a.filters.push([{
          alias: "type",
          compt: "selectbox",
          express: "like",
          id: 29,
          range: null,
          val: [params.type]
        }]) : '';
        params.keyword ? a.filters.push([{
          alias: "antiqueName",
          compt: "selectbox",
          express: "like",
          id: 1,
          range: null,
          val: [params.keyword]
        }]) : '';
      }
      query.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(query).then(res => {
        this.listTotal = res.totalPage;
        this.setListData(res.dataList, type);
      });
    },
    // 底部文物信息列表数据解析
    setListData(data, type) {
      let list = data.map((item, index) => {
        let nItem = {
          columnName: this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
          code: this.getValInFormData(item.formIdValueData, 'autoId'),
          type: this.getValInFormData(item.formIdValueData, 'type'),
          index: index,
          m_index: 0,
          autoCode: this.getValInFormData(item.formIdValueData, 'autoCode')
        };
        return nItem;
      });
      // 手动塞重复数据的index
      list.map(item => {
        if (list.filter(l => {
          return l.code == item.code;
        }).length > 1) {
          let f_list = list.filter(l => {
            return l.code == item.code;
          });
          f_list.map((f, i) => {
            list[f.index].m_index = i;
          });
        }
      });
      if (this.$route.query.autoCode) {
        // this.listPage > 1 ? list = list.filter((l) => {
        //   return l.autoCode != this.$route.query.autoCode
        // }) : ''
      } else {
        // this.listPage > 1 ? list = list.filter((l) => {
        //   return l.code != this.detailCode
        // }) : ''
      }
      this.list = this.list.concat(list);
      let that = this;
      if (this.listPage == 1) {
        this.$nextTick(() => {
          if (!this.isMobile && !this.$route.query.hideOthers) {
            this.swiperEl = new Swiper(this.$refs.swipercontainer, {
              navigation: {
                nextEl: ".btnTurnRight",
                prevEl: ".btnTurnLeft"
              },
              direction: 'vertical',
              slidesPerView: 'auto',
              initialSlide: 0,
              centeredSlides: true,
              runCallbacksOnInit: false,
              touchMoveStopPropagation: true,
              // slideToClickedSlide: true,
              observer: true,
              observeSlideChildren: true
            });
            let that = this;
            this.swiperEl.on('slideChangeTransitionEnd', function (e) {
              that.slideFun(e);
            });
          }
        });
        if (type == 'changeColumn') {
          this.detailCode = this.list[0].code;
          this.showModels = [false, false, false];
          this.$nextTick(() => {
            this.$refs.lsDetail.slideFun(this.detail);
          });
          return;
        }
        let m_index = this.$route.query.index || 0;
        console.log(this.list, this.detailCode);
        let activeIndex = this.list.findIndex((item, index) => {
          return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index);
        });
        console.log(activeIndex, 222);
        // 当前数据不在列表中，继续获取列表
        if (activeIndex == -1) {
          this.getActiveList();
        } else {
          this.activeIndex = activeIndex;
          this.$nextTick(() => {
            this.swiperEl ? this.swiperEl.slideTo(this.activeIndex) : '';
            this.showDetail = true;
          });
        }
      } else {
        if (this.activeIndex) return;
        let m_index = this.$route.query.index || 0;
        let activeIndex = this.list.findIndex(item => {
          return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index);
        });
        // 当前数据不在列表中，继续获取列表
        if (activeIndex == -1) {
          this.getActiveList();
        } else {
          this.activeIndex = activeIndex;
          console.log(activeIndex, 333);
          setTimeout(() => {
            this.$nextTick(() => {
              this.swiperEl ? this.swiperEl.slideTo(this.activeIndex) : '';
              this.showDetail = true;
            });
          });
        }
      }
    },
    // 获取当前数据在第几个
    getActiveList() {
      this.listPage++;
      this.getList();
    },
    // 切换底部文物
    slideFun(e) {
      if (this.listPage < this.listTotal) {
        if ((this.swiperEl.realIndex + 1) % 10 == 0 || this.swiperEl.realIndex + 1 > 10 * (this.listPage - 1) || this.swiperEl.realIndex == this.list.length) {
          this.listPage++;
          this.getList();
        }
      }
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    getValInFormData(data, id, type) {
      if (!data[id] || !data[id].groupValues[0] || !data[id].groupValues[0].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[0].values[0][0]) return;
        target = process.env.NODE_ENV == 'development' ? data[id].groupValues[0].values[0][0] : data[id].groupValues[0].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`;
      } else {
        target = type ? data[id].groupValues[0].values[0][0][type] : data[id].groupValues[0].values[0][0].val;
      }
      return target;
    }
  },
  mounted() {
    this.paramsData = window.sessionStorage.getItem("searchKey") ? JSON.parse(window.sessionStorage.getItem("searchKey")) : {};
    this.detailCode = this.$route.query.code;
    this.fileCode = this.$route.query.autoCode;
    this.getConfig();
    this.getColumn();
  },
  watch: {
    '$route'(to, from) {
      if (to.name == "new3DDetail") {
        location.reload();
      }
    }
  },
  created() {
    let list2 = ['img.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  }
};